var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "data-test": "toast-component"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.message)), _vm.destination ? _c('VButton', {
    staticClass: "white",
    on: {
      "click": _vm.goToDestination
    }
  }, [_vm._v(_vm._s(_vm.actionText))]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }